if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        const opener = this.openedBy;
        super.hide();
        if (opener && document.contains(opener)) opener.focus();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia(opener);
        const closeButton = this.querySelector('.product-media-modal__toggle');
        if (typeof trapFocus === 'function' && closeButton) {
          trapFocus(this, closeButton);
        }
      }

      showActiveMedia(opener) {
        const modalSwiper = this.querySelector('.swiper');
        const openerIndex = Number(opener.getAttribute('data-media-index')) || 1;
        const slideIndex = Math.max(openerIndex - 1, 0);
        if (modalSwiper?.swiper) {
          modalSwiper.swiper.slideTo(slideIndex, 0);
        } else if (typeof swiperMediaInstance !== 'undefined' && swiperMediaInstance) {
          swiperMediaInstance.slideTo(slideIndex, 0);
        }

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}

document.addEventListener('section:load', () => {
  const productModals = document.querySelectorAll('product-modal');
  if (productModals.length > 1) {
    for (let i = 0; i < productModals.length - 1; i++) {
      productModals[i].remove();
    }
  }
});
